<mp-toggle-filter
  filterName="Nur aktualisiert"
  icon="schedule"
  [checked]="filter()?.updatedOnly === true"
  (checkedChange)="handleFilterChanges({ updatedOnly: $event })"
/>

<mp-multi-selection-group
  filterName="Katalogtyp"
  icon="menu_book"
  [options]="catalogTypeFilterOptions"
  [selectedValues]="filter()?.catalogType ?? []"
  (selectedValuesChange)="handleFilterChanges({ catalogType: $event })"
/>

<mp-multi-selection-group
  filterName="Datenquellen"
  icon="topic"
  [searchable]="true"
  [sortOptionsBySelection]="true"
  searchFieldPlaceholder="Datenquellen durchsuchen"
  [options]="dataSourceFilterOptions()"
  [selectedValues]="filter()?.dataSources ?? []"
  (selectedValuesChange)="handleFilterChanges({ dataSources: $event })"
/>
